import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../../../components/ui/dialog';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/select';

export const ExpenseDialog = ({ open, onOpenChange, editingExpense, expenseForm, setExpenseForm, tournament, teams, expenseCategories, onSave }) => (
  <Dialog open={open} onOpenChange={(o) => { onOpenChange(o); }}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>{editingExpense ? 'Edit Expense' : 'Add Expense'}</DialogTitle>
        <DialogDescription>{editingExpense ? 'Update expense details' : 'Record a tournament expense'}</DialogDescription>
      </DialogHeader>
      <div className="space-y-4 py-4">
        <div>
          <Label>Expense Date</Label>
          <Input type="date" value={expenseForm.expense_date} onChange={(e) => setExpenseForm({ ...expenseForm, expense_date: e.target.value })} data-testid="expense-date-input" />
        </div>
        <div>
          <Label>Age Category (Optional)</Label>
          <Select value={expenseForm.age_category || 'general'} onValueChange={(value) => setExpenseForm({ ...expenseForm, age_category: value === 'general' ? '' : value, team_id: '' })}>
            <SelectTrigger data-testid="expense-age-category-select"><SelectValue placeholder="General (All Categories)" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="general">General (All Categories)</SelectItem>
              {tournament.age_categories?.map(cat => (<SelectItem key={cat} value={cat}>{cat.toUpperCase()}</SelectItem>))}
            </SelectContent>
          </Select>
        </div>
        {expenseForm.age_category && expenseForm.age_category !== 'general' && (
          <div>
            <Label>Team (Optional)</Label>
            <Select value={expenseForm.team_id || 'none'} onValueChange={(value) => setExpenseForm({ ...expenseForm, team_id: value === 'none' ? '' : value })}>
              <SelectTrigger data-testid="expense-team-select"><SelectValue placeholder="Select a team (optional)" /></SelectTrigger>
              <SelectContent>
                <SelectItem value="none">No specific team</SelectItem>
                {teams.filter(t => t.age_category === expenseForm.age_category).map(team => (
                  <SelectItem key={team.id} value={team.id}>{team.name}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        )}
        <div>
          <Label>Category</Label>
          <Select value={expenseForm.category} onValueChange={(value) => setExpenseForm({ ...expenseForm, category: value })}>
            <SelectTrigger data-testid="expense-category-select"><SelectValue placeholder="Select category" /></SelectTrigger>
            <SelectContent>
              {(expenseCategories || []).filter(c => c.is_active !== false).map(cat => (
                <SelectItem key={cat.code || cat.value} value={cat.code || cat.value}>{cat.name || cat.label}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label>Amount ($)</Label>
          <Input type="number" step="0.01" value={expenseForm.amount} onChange={(e) => setExpenseForm({ ...expenseForm, amount: parseFloat(e.target.value) || 0 })} data-testid="expense-amount-input" />
        </div>
        <div>
          <Label>Description (Optional)</Label>
          <Input value={expenseForm.description} onChange={(e) => setExpenseForm({ ...expenseForm, description: e.target.value })} placeholder="Additional details..." data-testid="expense-description-input" />
        </div>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
        <Button onClick={onSave} data-testid="save-expense-btn">{editingExpense ? 'Update Expense' : 'Add Expense'}</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
